import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { useQueryMonitor } from "../../../queries";
import { MONITORS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const MonitorEditorBreadcrumb: React.FC<{ id: string }> = ({ id }) => {
	const linkToMonitor = useNavigateToLink(MONITORS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
		params: { id },
	});

	const { isLoading, error, data: monitor } = useQueryMonitor(id);

	if (isLoading) {
		return <BreadcrumbLayout label="" />;
	}

	if (error || monitor == null) {
		return <BreadcrumbLayout label="Monitor not found" />;
	}

	return <BreadcrumbLayout label={monitor.name} to={linkToMonitor} />;
};
